import { useEffect, useState } from 'react'
import {Star, ChevronLeft, ChevronRight, Quote} from 'lucide-react'
import { testimonials } from '@/data/testimonials'

function TestimonialsCarousel() {
  const [index, setIndex] = useState(0)

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex(prev => (prev + 1) % testimonials.length)
    }, 6000)
    return () => clearInterval(interval)
  }, [])

  const current = testimonials[index]

  const goPrev = () => setIndex(prev => (prev - 1 + testimonials.length) % testimonials.length)
  const goNext = () => setIndex(prev => (prev + 1) % testimonials.length)

  return (
    <div className="relative mx-auto max-w-3xl">
      <div className="rounded-2xl border border-slate-100 bg-white p-8 shadow-sm sm:p-10">
        <Quote className="h-8 w-8 text-cyan-200" aria-hidden="true" />
        <p className="mt-4 text-lg leading-relaxed text-slate-700 sm:text-xl">
          "{current.quote}"
        </p>
        <div className="mt-6 flex items-center gap-4">
          <span className="flex h-11 w-11 items-center justify-center rounded-full bg-slate-900 text-sm font-semibold text-white">
            {current.initials}
          </span>
          <div>
            <p className="text-sm font-semibold text-slate-900">{current.name}</p>
            <p className="text-xs text-slate-500">{current.role} · {current.company}</p>
          </div>
          <div className="ml-auto flex items-center gap-0.5" aria-label={`Avaliação ${current.rating} de 5`}>
            {Array.from({ length: current.rating }).map((_, i) => (
              <Star key={i} className="h-4 w-4 fill-amber-400 text-amber-400" aria-hidden="true" />
            ))}
          </div>
        </div>
      </div>

      <div className="mt-6 flex items-center justify-center gap-3">
        <button
          type="button"
          onClick={goPrev}
          aria-label="Depoimento anterior"
          className="flex h-9 w-9 items-center justify-center rounded-full border border-slate-200 text-slate-500 hover:bg-slate-50"
        >
          <ChevronLeft className="h-4 w-4" aria-hidden="true" />
        </button>
        <div className="flex items-center gap-1.5">
          {testimonials.map((t, i) => (
            <button
              key={t.id}
              type="button"
              onClick={() => setIndex(i)}
              aria-label={`Ir para depoimento ${i + 1}`}
              className={`h-2 rounded-full transition-all ${i === index ? 'w-6 bg-cyan-600' : 'w-2 bg-slate-200'}`}
            />
          ))}
        </div>
        <button
          type="button"
          onClick={goNext}
          aria-label="Próximo depoimento"
          className="flex h-9 w-9 items-center justify-center rounded-full border border-slate-200 text-slate-500 hover:bg-slate-50"
        >
          <ChevronRight className="h-4 w-4" aria-hidden="true" />
        </button>
      </div>
    </div>
  )
}

export default TestimonialsCarousel
